import { render, staticRenderFns } from "./ShowSignatureDialog.vue?vue&type=template&id=9c5810ce&scoped=true"
import script from "./ShowSignatureDialog.vue?vue&type=script&lang=ts"
export * from "./ShowSignatureDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShowSignatureDialog.vue?vue&type=style&index=0&id=9c5810ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5810ce",
  null
  
)

export default component.exports